<template>
  <div class="page-content">
<!--    <FixedTool/>-->

    <div class="banner">
      <span class="banner-title">精选驾校</span>
      <div class="line"></div>
      <span class="banner-desc">为您推荐<br/>最合适的驾校或教练</span>
    </div>
    <div class="myform">
      <FreeForm ref="freeform" source="find_driving" :freeformsubmitsuccess="freeformsubmitsuccess"></FreeForm>
    </div>
    <div class="warning-text"><img src="../assets/images/icon_danger.png" alt="">提交成功后，推荐的驾校将会与你电话联系</div>
    <div class="footer">
      <div class="btn" @click="helpFindDriving">帮我找驾校</div>
      <p>如有任何疑问请联系我们<br/>电话：<a :href="'tel://'+conf.card_phone" style="color:#999;">{{ conf.card_phone }}</a> 微信号：
        <a href="javascript:void(0)" style="color:#999;" @click="copy(conf.card_wechat)">{{ conf.card_wechat }}</a></p>
    </div>
  </div>
</template>

<script>
import FreeForm from '@/components/FreeForm'

export default {
  name: 'FindDriving',
  components: {FreeForm},
  data() {
    return {

      conf: {},
      loc: '',
    }
  },
  methods: {
    freeformsubmitsuccess() {
      this.$router.go(-1);
    },
    // 提交表单
    helpFindDriving() {
      this.$refs.freeform.submit();
    },
    copy(text) {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', text)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$toast.text('复制成功');
      }
      document.body.removeChild(input)
    },
  },
  created() {
    this.$ajax.get('/m/system/conf').then(res => {
      this.conf = res;

    })

  },

  activated() {

  },
  mounted() {
    window.document.title = '帮我找驾校';
    setTimeout(()=>{
      window.document.title = '帮我找驾校';
    },3500);
    setTimeout(()=>{
      window.document.title = '帮我找驾校';
    },1500);
    setTimeout(()=>{
      window.document.title = '帮我找驾校';
    },4500);
  }
}
</script>

<style lang="less" scoped>
.page-content {
  width: 100%;

  .banner {
    width: 100%;
    height: 184px;
    background-image: url(../assets/images/find_d_banner.png);
    background-color: #2B82ED;
    box-sizing: border-box;
    padding-left: 43px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;

    .banner-title {
      font-size: 22px;
    }

    .line {
      width: 94px;
      height: 1px;
      background: linear-gradient(243deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
      margin-top: 5px;
    }

    .banner-desc {
      font-size: 13px;
      line-height: 17px;
      margin-top: 6px;
    }
  }

  .myform {
    width: 100%;
    margin-top: -7px;
    position: relative;
    z-index: 199;
    background-color: #fff;
    border-radius: 6px 6px 0px 0px;
  }

  .warning-text {
    font-size: 10px;
    color: #EB273B;
    text-align: center;

    img {
      padding-right: 3px;
    }
  }

  .footer {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
    margin-top: 20px;

    .btn {
      width: 100%;
      height: 40px;
      background: linear-gradient(222deg, rgba(0, 194, 255, 1) 0%, rgba(60, 67, 236, 1) 100%);
      border-radius: 25px;
      line-height: 40px;
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      color: #fff;
    }

    p {
      font-size: 12px;
      color: #999;
      margin-top: 10px;
      line-height: 15px;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
